import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ROUTES from './routes.json';
import { applySeo, organizationJsonLd, webSiteJsonLd, SeoInput } from './tags';

interface RouteSeo {
  title: string;
  description: string;
  /** Set on legacy duplicate URLs: the route they are a copy of. */
  canonical?: string;
  /** "organization" adds the Organization + WebSite JSON-LD (home page). */
  schema?: 'organization';
}

const TABLE = ROUTES as Record<string, RouteSeo>;

/** SEO input for a static route, or null for pages that set their own tags
 *  (/blog/:slug, /countries/:slug, 404). */
export function routeSeo(pathname: string): SeoInput | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  const entry = TABLE[path];
  if (!entry) return null;
  return {
    title: entry.title,
    description: entry.description,
    path,
    canonical: entry.canonical,
    jsonLd: entry.schema === 'organization' ? [organizationJsonLd(), webSiteJsonLd()] : undefined,
  };
}

/** Mounted once inside the router (App.tsx Shell): re-applies the static
 *  route's tags on every navigation. Renders nothing. */
const Seo: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = routeSeo(pathname);
    if (seo) applySeo(seo);
  }, [pathname]);

  return null;
};

export default Seo;
